import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appNumericInput]'
})
export class NumericInputDirective {
  constructor(private ngControl: NgControl) {}

  @HostListener('input', ['$event.target.value'])
  onInputChange(value: string): void {
    // Replace invalid characters and formats
    const sanitizedValue = value
      .replace(/[^0-9.\-]/g, '') // Allow only numbers, dot, and hyphen
      .replace(/(\..*?)\..*/g, '$1') // Prevent multiple dots
      .replace(/(?!^)-/g, '') // Prevent hyphens after the first character
      .replace(/^(-?)0+(?=\d)/, '$1'); // Remove leading zeros

    // Update the form control's value
    if (this.ngControl.control && sanitizedValue !== value) {
      this.ngControl.control.setValue(sanitizedValue, { emitEvent: false });
    }
  }
}